import {
  lucideAlignCenter,
  lucideAlignLeft,
  lucideAlignRight,
  lucideArchive,
  lucideArrowDown,
  lucideArrowLeft,
  lucideArrowLeftRight,
  lucideArrowRight,
  lucideArrowUp,
  lucideArrowUpRight,
  lucideBadgeCheck,
  lucideBan,
  lucideBell,
  lucideBellOff,
  lucideBellRing,
  lucideBinoculars,
  lucideBlocks,
  lucideBold,
  lucideBookmarkPlus,
  lucideBookOpen,
  lucideBookOpenText,
  lucideBot,
  lucideBringToFront,
  lucideCalendar,
  lucideCalendar1,
  lucideCalendarPlus,
  lucideCheck,
  lucideCheckCheck,
  lucideChevronsUpDown,
  lucideChevronDown,
  lucideChevronLeft,
  lucideChevronRight,
  lucideChevronUp,
  lucideCircle,
  lucideCircleAlert,
  lucideCircleCheck,
  lucideCircleCheckBig,
  lucideCircleDollarSign,
  lucideCirclePlus,
  lucideCircleSmall,
  lucideCircleStop,
  lucideCircleX,
  lucideClipboard,
  lucideClock,
  lucideCloudUpload,
  lucideCode,
  lucideCodeXml,
  lucideComputer,
  lucideCopy,
  lucideCornerDownRight,
  lucideCpu,
  lucideCreditCard,
  lucideDatabase,
  lucideDownload,
  lucideEllipsis,
  lucideExpand,
  lucideExternalLink,
  lucideEye,
  lucideFlame,
  lucideFile,
  lucideFileDown,
  lucideFilePen,
  lucideFilePenLine,
  lucideFilePlus,
  lucideFileSearch,
  lucideFileSpreadsheet,
  lucideFileText,
  lucideFileStack,
  lucideFileX,
  lucideFolder,
  lucideFolders,
  lucideFolderClosed,
  lucideFolderCode,
  lucideFolderOpen,
  lucideFolderPlus,
  lucideGitCompare,
  lucideGlobe,
  lucideGripHorizontal,
  lucideGripVertical,
  lucideHandHelping,
  lucideHeadset,
  lucideHeart,
  lucideHistory,
  lucideHourglass,
  lucideHouse,
  lucideImagePlus,
  lucideInbox,
  lucideInfo,
  lucideItalic,
  lucideLayers,
  lucideLayers2,
  lucideLayoutDashboard,
  lucideLayoutGrid,
  lucideLayoutTemplate,
  lucideLightbulb,
  lucideLightbulbOff,
  lucideLibraryBig,
  lucideLink,
  lucideList,
  lucideListChecks,
  lucideListFilterPlus,
  lucideListTodo,
  lucideLoader,
  lucideLoaderCircle,
  lucideLock,
  lucideLogOut,
  lucideMail,
  lucideMaximize2,
  lucideMessageCircle,
  lucideMessageCircleDashed,
  lucideMessageCircleMore,
  lucideMessageCircleOff,
  lucideMessageCirclePlus,
  lucideMessageCircleQuestion,
  lucideMessageCircleWarning,
  lucideMessageCircleX,
  lucideMessageSquare,
  lucideMessagesSquare,
  lucideMessageSquareMore,
  lucideMic,
  lucideMinimize2,
  lucideMinus,
  lucideMonitor,
  lucideMoon,
  lucideMoveRight,
  lucideNetwork,
  lucidePalette,
  lucidePanelLeft,
  lucidePanelLeftOpen,
  lucidePanelRightClose,
  lucidePanelRightOpen,
  lucidePause,
  lucidePencil,
  lucidePlay,
  lucidePlus,
  lucidePopcorn,
  lucidePuzzle,
  lucideRefreshCw,
  lucideRuler,
  lucideSave,
  lucideSearch,
  lucideSend,
  lucideSettings,
  lucideSettings2,
  lucideShare2,
  lucideShapes,
  lucideShield,
  lucideSmartphone,
  lucideSparkle,
  lucideSparkles,
  lucideSquare,
  lucideSquareArrowDown,
  lucideSquareLibrary,
  lucideSquarePlay,
  lucideSquareUserRound,
  lucideStar,
  lucideSun,
  lucideTablet,
  lucideTag,
  lucideTerminal,
  lucideThumbsDown,
  lucideThumbsUp,
  lucideTrash,
  lucideTrash2,
  lucideTrendingDown,
  lucideTriangleAlert,
  lucideUnderline,
  lucideUpload,
  lucideUser,
  lucideUsers,
  lucideWrench,
  lucideX,
  lucideZap,
  lucideEllipsisVertical,
  lucideImage,
  lucideCog,
  lucideSigma,
  lucideUserRoundSearch,
  lucideFilter,
  lucideSlidersHorizontal,
  lucideColumns3,
  lucideCircleHelp,
  lucidePackage,
  lucideChartPie,
  lucideBrickWall,
  lucideUserRound,
  lucideBuilding2,
  lucideTags,
  lucideFileType,
  lucideFlag,
  lucideGauge,
} from '@ng-icons/lucide';

/**
 * All Lucide icons used across the application, registered for use with
 * @ng-icons/core via provideIcons(). Add new icons here as needed.
 *
 * Note: Some icon names differ between lucide-angular (older names) and
 * @ng-icons/lucide (newer names after Lucide renames):
 *   AlertTriangle    → lucideTriangleAlert
 *   CheckCircle      → lucideCircleCheckBig
 *   CheckCircle2     → lucideCircleCheck
 *   Loader2          → lucideLoaderCircle
 *   XCircle          → lucideCircleX
 *   FileEdit         → lucideFilePen
 */
export const APP_LUCIDE_ICONS = {
  lucideAlignCenter,
  lucideAlignLeft,
  lucideAlignRight,
  lucideArchive,
  lucideArrowDown,
  lucideArrowLeft,
  lucideArrowLeftRight,
  lucideArrowRight,
  lucideArrowUp,
  lucideArrowUpRight,
  lucideBadgeCheck,
  lucideBan,
  lucideBell,
  lucideBellOff,
  lucideBellRing,
  lucideBinoculars,
  lucideBlocks,
  lucideBold,
  lucideBookmarkPlus,
  lucideBookOpen,
  lucideBookOpenText,
  lucideBot,
  lucideBringToFront,
  lucideCalendar,
  lucideCalendar1,
  lucideCalendarPlus,
  lucideCircleHelp,
  lucideCheck,
  lucideCheckCheck,
  lucideChevronsUpDown,
  lucideChevronDown,
  lucideChevronLeft,
  lucideChevronRight,
  lucideChevronUp,
  lucideCircle,
  lucideCircleAlert,
  lucideCircleCheck,
  lucideCircleCheckBig,
  lucideCircleDollarSign,
  lucideCirclePlus,
  lucideCircleSmall,
  lucideCircleStop,
  lucideCircleX,
  lucideClipboard,
  lucideClock,
  lucideCloudUpload,
  lucideCode,
  lucideCodeXml,
  lucideComputer,
  lucideCopy,
  lucideCornerDownRight,
  lucideCpu,
  lucideCreditCard,
  lucideDatabase,
  lucideDownload,
  lucideEllipsis,
  lucideEllipsisVertical,
  lucideExpand,
  lucideExternalLink,
  lucideEye,
  lucideFlame,
  lucideFile,
  lucideFileDown,
  lucideFilePen,
  lucideFilePenLine,
  lucideFilePlus,
  lucideFileSearch,
  lucideFileSpreadsheet,
  lucideFileText,
  lucideFileStack,
  lucideFileX,
  lucideFolder,
  lucideFolders,
  lucideFolderClosed,
  lucideFolderCode,
  lucideFolderOpen,
  lucideFolderPlus,
  lucideGitCompare,
  lucideGlobe,
  lucideGripHorizontal,
  lucideGripVertical,
  lucideHandHelping,
  lucideHeadset,
  lucideHeart,
  lucideHistory,
  lucideHourglass,
  lucideHouse,
  lucideImagePlus,
  lucideInbox,
  lucideInfo,
  lucideItalic,
  lucideLayers,
  lucideLayers2,
  lucideLayoutDashboard,
  lucideLayoutGrid,
  lucideLayoutTemplate,
  lucideLightbulb,
  lucideLightbulbOff,
  lucideLibraryBig,
  lucideLink,
  lucideList,
  lucideListChecks,
  lucideListFilterPlus,
  lucideListTodo,
  lucideLoader,
  lucideLoaderCircle,
  lucideLock,
  lucideLogOut,
  lucideMail,
  lucideMaximize2,
  lucideMessageCircle,
  lucideMessageCircleDashed,
  lucideMessageCircleMore,
  lucideMessageCircleOff,
  lucideMessageCirclePlus,
  lucideMessageCircleQuestion,
  lucideMessageCircleWarning,
  lucideMessageCircleX,
  lucideMessageSquare,
  lucideMessagesSquare,
  lucideMessageSquareMore,
  lucideMic,
  lucideMinimize2,
  lucideMinus,
  lucideMonitor,
  lucideMoon,
  lucideMoveRight,
  lucideNetwork,
  lucidePalette,
  lucidePanelLeft,
  lucidePanelLeftOpen,
  lucidePanelRightClose,
  lucidePanelRightOpen,
  lucidePause,
  lucidePencil,
  lucidePlay,
  lucidePlus,
  lucidePopcorn,
  lucidePuzzle,
  lucideRefreshCw,
  lucideRuler,
  lucideSave,
  lucideSearch,
  lucideSend,
  lucideSettings,
  lucideSettings2,
  lucideShare2,
  lucideShapes,
  lucideShield,
  lucideSmartphone,
  lucideSparkle,
  lucideSparkles,
  lucideSquare,
  lucideSquareArrowDown,
  lucideSquareLibrary,
  lucideSquarePlay,
  lucideSquareUserRound,
  lucideStar,
  lucideSun,
  lucideTablet,
  lucideTag,
  lucideTerminal,
  lucideThumbsDown,
  lucideThumbsUp,
  lucideTrash,
  lucideTrash2,
  lucideTrendingDown,
  lucideTriangleAlert,
  lucideUnderline,
  lucideUpload,
  lucideUser,
  lucideUsers,
  lucideWrench,
  lucideX,
  lucideZap,
  lucideImage,
  lucideCog,
  lucideSigma,
  lucideUserRoundSearch,
  lucideFilter,
  lucideSlidersHorizontal,
  lucideColumns3,
  lucidePackage,
  lucideChartPie,
  lucideBrickWall,
  lucideUserRound,
  lucideBuilding2,
  lucideTags,
  lucideFileType,
  lucideFlag,
  lucideGauge
};

/**
 * Converts a kebab-case Lucide icon key (as used in ZARD_ICONS and
 * throughout templates) to the camelCase ng-icons name.
 *
 * Examples:
 *   'chevron-right'  → 'lucideChevronRight'
 *   'file-text'      → 'lucideFileText'
 *   'settings-2'     → 'lucideSettings2'
 */
export function toNgIconName(kebabKey: string): string {
  const pascal = kebabKey
    .split('-')
    .map(part => part.charAt(0).toUpperCase() + part.slice(1))
    .join('');
  return `lucide${pascal}`;
}
